var _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVagetable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31_0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      width: "current",
      height: "current",
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:current;stroke:current}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "179.685,336.941 179.536,337.066 179.579,336.819 158.423,354.952 150.732,361.467 150.786,361.499  150.658,361.608 173.029,373.592 176.716,352.89  ",
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.782,195.571c1.957-11.03,5.808-21.62,11.144-31.323c1.449-2.558,2.953-5.094,4.633-7.492 c-0.102,0.054-0.172,0.133-0.274,0.191c0.07-0.106,0.125-0.226,0.199-0.332c-2.246,1.242-4.43,2.714-6.434,4.488L94.467,263.571 c-23.078,19.832-16.293,59.319,13.102,75.018l17.828,9.562l61.62-52.827L204.782,195.571z",
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.31,422.713l-3.171-9.215l-0.043,0.035l-0.058-0.16l-33.992,26.851l-13.683,10.726l0.062,0.031 l-0.137,0.11l37.066,19.828c14.402,7.675,29.16-4.954,23.73-20.301L369.31,422.713z",
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "87.249,232.524 110.795,212.337 113.374,210.15 113.362,210.138 113.482,210.032 62.566,162.159  27.3,162.67 0.098,162.939 0.25,163.06 0,163.064  ",
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "187.638,146.463 162.834,104.562 144.466,73.304 144.431,73.48 144.31,73.273 133.342,130.592  161.404,168.959  ",
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "124.326,200.739 150.56,178.251 69.386,75.792 36.659,90.245 25.82,94.975 25.859,95.015  25.702,95.085  ",
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M444.22,206.115l-113.299-67.792c-19.644-11.754-44.46-11.48-66.437,0.684 c-21.96,12.238-37.742,34.554-42.242,59.674l-42.346,237.395c-3.657,20.425,4.273,39.765,20.25,49.327 c15.98,9.558,36.812,7.43,53.085-5.453l130.631-103.237l58.546-46.3c20.05-15.817,32.21-40.297,32.613-65.437 C475.352,239.864,463.86,217.868,444.22,206.115z M305.136,277.071v-0.004l0.141,0.082l11.718-19.586l0.004-0.008l0,0l0.082-0.137 l-64.979-38.878l0.004-0.019l3.058-17.106c0.606-3.406,1.594-6.641,2.875-9.679c0.152-0.352,0.324-0.692,0.484-1.039 c1.035-2.286,2.258-4.43,3.622-6.461c0.41-0.61,0.801-1.234,1.238-1.824c0.746-1,1.531-1.958,2.348-2.887 c0.504-0.566,1.035-1.102,1.562-1.644c1.676-1.715,3.457-3.294,5.347-4.692c0.286-0.214,0.563-0.441,0.852-0.648 c11.531-8.09,26.328-10.09,38.605-2.742l113.291,67.784c21.902,13.106,21.422,47.468-0.946,65.12l-50.51,39.93l-35.183-21.05 l-0.121-0.074l0,0l-0.137-0.082l-11.734,19.61l-0.004,0.008l0,0l-0.082,0.136l20.738,12.406l7.16,4.351l-119.33,94.35 c-5.461,4.293-11.699,4.375-16.258,1.649c-4.558-2.727-7.434-8.266-6.234-15.102l19.77-110.596l30.866,18.465l0.059,0.038v-0.003 l0.137,0.082l11.734-19.605l0.004-0.008l0,0l0.082-0.137l-38.562-23.074l8.121-45.426l2.879-15.785l57.194,34.218L305.136,277.071z ",
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "406.892,72.601 393.576,42.395 384.146,20.723 384.088,20.879 383.994,20.668 348.616,117.256  377.17,134.346  ",
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "458.974,124.866 431.888,162.033 429.407,165.412 429.419,165.42 429.326,165.549 457.88,182.635  489.633,146.959 512,121.999 511.84,122.011 511.992,121.839  ",
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "388.97,141.405 417.525,158.491 480.278,64.547 483.262,60.093 483.254,60.09 483.344,59.957  446.693,38.027 444.826,36.903 444.822,36.91 444.685,36.824  ",
    style: {
      fill: "rgb(75, 75, 75)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVagetable);
export default __webpack_public_path__ + "static/media/Vagetable.25abac80626d98e9ad259eee9df59d28.svg";
export { ForwardRef as ReactComponent };